import { Controller } from "@hotwired/stimulus"

// コメントモーダルの表示制御（UC-028）
export default class extends Controller {
  static targets = ["dialog", "title", "body"]

  connect() {
    if (this.dialogTarget.open) {
      this.dialogTarget.close()
    }
    this.dialogTarget.classList.add("hidden")
  }

  open(event) {
    if (this.dialogTarget.open) return

    const trigger = event.currentTarget
    const title = trigger.dataset.commentTitle || ""
    const body = trigger.dataset.commentBody || ""

    this.titleTarget.textContent = title
    this.bodyTarget.textContent = body

    this.dialogTarget.classList.remove("hidden")
    this.dialogTarget.showModal()
  }

  close() {
    if (!this.dialogTarget.open) return

    this.dialogTarget.close()
    this.dialogTarget.classList.add("hidden")
  }

  backdropClose(event) {
    if (event.target === this.dialogTarget) {
      this.close()
    }
  }

  handleCancel(event) {
    event.preventDefault()
    this.close()
  }

  syncVisibility() {
    if (!this.dialogTarget.open) {
      this.dialogTarget.classList.add("hidden")
    }
  }
}
